// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"536c712cf32bad7d","777":"d27e23d478a71886"}[chunkId] + ".js";
};